/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    UNIVERSALIMPORTER_PLANS_RECEIVE,
    UNIVERSALIMPORTER_PLANS_REQUEST,
    UNIVERSALIMPORTER_PLANS_REQUEST_SUCCESS,
    UNIVERSALIMPORTER_PLANS_REQUEST_FAILURE,
    CURRENT_UNIVERSALIMPORTER_RECEIVE,
} from 'state/action-types';

export const items = createReducer([], {
    [UNIVERSALIMPORTER_PLANS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [UNIVERSALIMPORTER_PLANS_REQUEST]: () => true,
    [UNIVERSALIMPORTER_PLANS_REQUEST_SUCCESS]: () => false,
    [UNIVERSALIMPORTER_PLANS_REQUEST_FAILURE]: () => false,
});


export const error = createReducer(false, {
    [UNIVERSALIMPORTER_PLANS_REQUEST]: () => false,
    [UNIVERSALIMPORTER_PLANS_REQUEST_SUCCESS]: () => false,
    [UNIVERSALIMPORTER_PLANS_REQUEST_FAILURE]: () => true,
});


export default combineReducers({
    items,
    requesting,
    error
});
